import { axiosInstance } from "./axiosInstance";

export const AuthService = {
    login: async (data) => {
        return await axiosInstance.post('/api/auth/admin/login', data)
    },
    logout: async () => {
        return await axiosInstance.post('/api/auth/logout')
    },
    loginAs: async (id) => {
        return await axiosInstance.get(`/api/auth/admin/login-as/${id}`)
    },
    unlock: async (id) => {
        return await axiosInstance.post(`/api/feature/user/unlock/${id}`)
    }
}